<div>
  <span class="bar-title">{{ text }}</span>
</div>
<div class="bar-base">
  <div class="progress animation-one"></div>
  <div class="progress animation-two"></div>
</div>
